var app = angular.module('leonardo');

var IntegerFormat = function () {
  return {
    restrict: 'A',
    require: ['ngModel'],
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.init = false;

      scope.$watch(attrs.ngModel, function(value) {
        if (!isNull(value) || scope.init) {
          scope.ngModelCtrl.$setViewValue(isNull(value) ? '' : parseInt(value).toString());
        }
        scope.init = true;
      });


      scope.setInputFilter = function (textbox, inputFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
          textbox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
          });
        });
      };

      scope.setInputFilter(element[0], function(value) {
        return /^-?\d*$/.test(value);
      });
    }
  };
};

app.directive('integerFormat', [IntegerFormat]);